import { styled } from '@mui/material';

import { Select } from '@app-velocity/ui';

import { SinglePersona } from './components/SinglePersona';
import { LEGACY_PERSONAS } from './constants';
import { useGetPersonasQuery } from '../../query';

export type PersonaOption = {
  id: string;
  name: string;
};

export type PersonaSelectorProps = {
  value: string;
  variant?: 'filled' | 'outlined';
  className?: string;
  disabled?: boolean;
  teamId: string;
  // displays only legacy personas
  legacy?: boolean;
  onChange: (newPersona: string) => void;
};

const StyledWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  width: '100%',
}));

const StyledSelectWrapper = styled('div')({
  flex: 1,
  minWidth: 0,
});

export const PersonaSelector = ({
  variant,
  onChange,
  value,
  disabled,
  className,
  legacy,
  teamId,
}: PersonaSelectorProps) => {
  const { data: personas = [], isLoading } = useGetPersonasQuery(teamId);

  const getSelectedLabel = (selected: string) => {
    if (
      LEGACY_PERSONAS.includes(selected as (typeof LEGACY_PERSONAS)[number])
    ) {
      return undefined;
    }

    return personas.find((persona) => persona.id === selected)?.name;
  };

  return (
    <StyledWrapper className={className}>
      <StyledSelectWrapper>
        <Select
          variant={variant || 'filled'}
          disabled={disabled || isLoading}
          value={value}
          onChange={(e) => onChange(e.target.value as string)}
          MenuProps={{ disablePortal: true }}
          renderValue={(selected: unknown) => (
            <SinglePersona
              value={selected as string}
              label={getSelectedLabel(selected as string)}
            />
          )}
        >
          {LEGACY_PERSONAS.map((legacyPersona) => (
            <Select.Item key={legacyPersona} value={legacyPersona}>
              {/* legacy prop is deciding whether to display LEGACY badge (web only) */}
              <SinglePersona value={legacyPersona} legacy={!legacy} />
            </Select.Item>
          ))}
          {!legacy &&
            personas.map((persona) => (
              <Select.Item key={persona.id} value={persona.id}>
                <SinglePersona value={persona.id!} label={persona.name} />
              </Select.Item>
            ))}
        </Select>
      </StyledSelectWrapper>
    </StyledWrapper>
  );
};
